import type { IcbtTranslations } from "@mindlercare/icbt";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useIcbtTranslations = (): IcbtTranslations => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      REASSIGN: t("REASSIGN"),
      INITIATED_BY_PATIENT: t("INITIATED_BY_PATIENT"),
      COMPLETED: t("COMPLETED"),
      IN_PROGRESS: t("IN_PROGRESS"),
      NOT_STARTED: t("NOT_STARTED"),
      ICBT_LOADING_DATA_ERROR_FORBIDDEN: t("ICBT_LOADING_DATA_ERROR_FORBIDDEN"),
      ICBT_LOADING_DATA_ERROR: t("ICBT_LOADING_DATA_ERROR"),
      ICBT_PROGRAM_PAGE_BY_PAGE: t("ICBT_PROGRAM_PAGE_BY_PAGE"),
      OF: t("OF"),
      ADD_FEEDBACK_DATE: t("ADD_FEEDBACK_DATE"),
      ASSIGN: t("ASSIGN"),
      CANCEL: t("CANCEL"),
      SEARCH: t("SEARCH"),
      PROGRAMS_ASSIGNED: t("PROGRAMS_ASSIGNED"),
      VIEW_ICBT_PAGE: t("VIEW_ICBT_PAGE"),
      NO_ANSWER: t("NO_ANSWER"),
      icbtsToAssign: (count: number) => t("icbtsToAssign", { count }),
    }),
    [t],
  );
};
